import React from 'react';
import classes from './BuildControl.css';

const BuildControl= (props)=>{

	return(
		<div className={classes.BuildControl} >
      <div className    ={classes.Label} >{props.label}</div>
      <button className ={classes.Less} onClick={()=> props.click(props.type, '-')} >-</button>
      <button className ={classes.More} onClick={()=> props.click(props.type, '+')} >+</button>
		</div>
		)
}

export default BuildControl;



// WEBPACK FOOTER //
// ./src/components/BuildControl/BuildControl.jsx